import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline'; // Original outline variant

interface DarkModeIconsProps {
  isDark: boolean;
  className?: string;
}

export const DarkModeIcons: React.FC<DarkModeIconsProps> = ({ isDark, className = 'h-6 w-6' }) => (
  <div className="">
    <SunIcon
      className={`${className} ${isDark ? 'hidden' : ''}`}
      style={{
        stroke: 'url(#brand-gradient-sun)',
        strokeWidth: '2',
      }}
    />
    <MoonIcon
      className={`${className} ${isDark ? '' : 'hidden'}`}
      style={{
        stroke: 'url(#brand-gradient-moon)',
        strokeWidth: '2',
      }}
    />
  </div>
);
